/* eslint-disable import/prefer-default-export */

export const barChartBase = {
  chart: {
    backgroundColor: 'transparent',
    type: 'bar',
    width: 800
  },
  title: {
    text: ''
  },
  xAxis: {
    min: 0,
    lineWidth: 0,
    title: {
      text: ''
    }
  },
  yAxis: {
    gridLineColor: '#fff',
    labels: {
      enabled: false
    },
    min: 0,
    title: {
      text: ''
    },
    stackLabels: {
      enabled: true,
      style: {
        fontWeight: 'bold',
        color: 'gray'
      }
    }
  },
  tooltip: {
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y}</b></td></tr>',
    footerFormat: '</table>',
    useHTML: true
  },
  plotOptions: {
    bar: {
      stacking: 'normal',
      stackLabels: {
        align: 'right'
      },
      borderRadius: 8,
      dataLabels: {
        enabled: true
      }
    },
    series: {
      color: '#3D59A8',
      pointWidth: 26,
      dataLabels: {
        color: '#000',
        style: {
          textOutline: false
        }
      }
    }
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false
  }
};
